import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import {
  CreateEventComponent
} from "@deltager/organizers/admin/modules/events/create-event/create-event-wizard/create-event.component";
import { Observable } from "rxjs";

@Injectable()
export class CanDeactivateGuard  {
  component: CreateEventComponent;
  route: ActivatedRouteSnapshot;

  constructor() {
  }

  canDeactivate(
    component: CreateEventComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return component?.canExit() ?? true;
  }

}
